package com.sweetlime.bingeamigo.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.functions.functions
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class FirebaseAuthRepository : AuthRepository {

    private val auth by lazy { Firebase.auth }

    override suspend fun login(
        email: String,
        password: String
    ) {

        auth.signInWithEmailAndPassword(
            email,
            password
        )
    }

    override suspend fun signup(
        email: String,
        password: String
    ) {

        auth.createUserWithEmailAndPassword(
            email,
            password
        )
    }

    override suspend fun sendEmailVerification() {
        auth.currentUser?.sendEmailVerification()
    }

    override fun isEmailVerified(): Boolean =
        auth.currentUser?.isEmailVerified == true

    override suspend fun reloadUser() {
        auth.currentUser?.reload()
    }

    override fun currentUserEmail(): String? =
        auth.currentUser?.email

    override fun currentUserId(): String? {
        return auth.currentUser?.uid
    }

    override fun authStateChanged(): Flow<String?> =
        auth.authStateChanged.map { it?.uid }

    override suspend fun logout() {
        auth.signOut()
    }

    override suspend fun deleteAccount() {
        // Deletion runs in the `deleteAccount` Cloud Function with admin
        // privileges: it purges all Firestore data and the auth account, and
        // avoids the client-side "requires-recent-login" reauth requirement.
        Firebase.functions.httpsCallable("deleteAccount").invoke()
        auth.signOut()
    }

    override suspend fun sendPasswordResetEmail(email: String) {
        auth.sendPasswordResetEmail(email)
    }
}